import { Action } from "redux";
import { PagesState, initialPagesState } from "./state";
import { getClientsRequest, getCustomerRequest, getBackendVersionRequest, postSupportMessageRequest } from "@common";
import { openNotificationAction, closeNotificationAction, changeDashboardLinkAction } from "./actions";

export function pageReducer(state: PagesState = initialPagesState as PagesState, action: Action): PagesState {
    if (getClientsRequest.actions.isMy(action)) {
        return {
            ...state,
            clients: getClientsRequest.reducer(state.clients, action)
        };
    }

    if (openNotificationAction.is(action)) {
        return {
            ...state,
            notification: {
                isOpen: true,
                message: action.message,
                isWarning: action.isWarning
            }
        };
    }

    if (changeDashboardLinkAction.is(action)) {
        return {
            ...state,
            dashboardLink: action.link
        };
    }

    if (closeNotificationAction.is(action)) {
        return {
            ...state,
            notification: {
                isOpen: false,
                message: ""
            }
        };
    }

    if (getCustomerRequest.actions.isMy(action)) {
        return {
            ...state,
            customer: getCustomerRequest.reducer(state.customer, action)
        };
    }

    if (getBackendVersionRequest.actions.isMy(action)) {
        return {
            ...state,
            backendVersion: getBackendVersionRequest.reducer(state.backendVersion, action)
        };
    }

    if (postSupportMessageRequest.actions.isMy(action)) {
        return {
            ...state,
            supportMessage: postSupportMessageRequest.reducer(state.supportMessage, action)
        };
    }

    return state;
}
